var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c("h1", [_vm._v("Help")]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "tabs fx-hidden--small fx-hidden--medium" },
      _vm._l(_vm.categories, function(category, index) {
        return _c("li", { key: category.label, staticClass: "tabs__item" }, [
          _c(
            "button",
            {
              staticClass: "tabs__button",
              class: {
                "tabs__button--active": _vm.selectedCategoryIndex === index
              },
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.setSelectedCategoryIndex(index)
                }
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "tabs__button-inner",
                  class: {
                    "tabs__button-inner--last":
                      _vm.categories.length - 1 === index
                  }
                },
                [_vm._v(_vm._s(category.label))]
              )
            ]
          )
        ])
      })
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "filter fx-hidden--large fx-hidden--full" },
      [
        _c(
          "fx-select",
          {
            attrs: { options: _vm.categories, "default-option": null },
            on: {
              input: function($event) {
                _vm.setSelectedCategoryIndex(_vm.selectedCategoryIndex)
              }
            },
            model: {
              value: _vm.selectedCategoryIndex,
              callback: function($$v) {
                _vm.selectedCategoryIndex = $$v
              },
              expression: "selectedCategoryIndex"
            }
          },
          [
            _c("span", {
              staticClass: "icon-chevron-lg-down",
              attrs: { slot: "caret" },
              slot: "caret"
            })
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.selectedCategoryIndex === _vm.categories.length - 1
      ? _c(
          "div",
          { staticClass: "contact" },
          [
            _c("div", { staticClass: "contact__row" }, [
              _c("section", { staticClass: "contact__section" }, [
                _c("h3", { staticClass: "contact__heading" }, [
                  _vm._v("Send us an email")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                    Contact our customer service team now at "
                  ),
                  _c("a", { attrs: { href: "mailto:" + _vm.emailAddress } }, [
                    _vm._v(_vm._s(_vm.emailAddress))
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n                    We’ll get back to you promptly.\n                "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "contact__action",
                    attrs: { href: "mailto:" + _vm.emailAddress }
                  },
                  [_vm._v("Send Email")]
                )
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "contact__section" }, [
                _c("h3", { staticClass: "contact__heading" }, [
                  _vm._v("Give us a call")
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm.isPhone
                  ? _c(
                      "a",
                      {
                        staticClass: "contact__action",
                        attrs: {
                          href: "tel:" + _vm.phoneNumber.replace(/\D/g, "")
                        }
                      },
                      [_vm._v("Get Number")]
                    )
                  : _vm.isShowPhoneNumber
                  ? _c(
                      "span",
                      {
                        staticClass: "contact__action contact__action--terminal"
                      },
                      [_vm._v(_vm._s(_vm.phoneNumber))]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "contact__action",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.isShowPhoneNumber = true
                          }
                        }
                      },
                      [_vm._v("Get Number")]
                    )
              ])
            ]),
            _vm._v(" "),
            _c("partner-contact")
          ],
          1
        )
      : _c(
          "ul",
          _vm._l(_vm.categories[_vm.selectedCategoryIndex].sections, function(
            section
          ) {
            return _c(
              "li",
              { key: section.heading, staticClass: "section" },
              [
                _c("collapsible", {
                  attrs: {
                    "body-html": section.bodyHtml,
                    heading: section.heading
                  }
                })
              ],
              1
            )
          })
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n                    Give us a call and we will be happy to assist you.\n                    "
      ),
      _c("br"),
      _vm._v("\n                    Mon-Sun 9am - 9pm (EST).\n                ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }